import { useMemo } from 'react';
import { isFunction } from 'lodash-es';
import { useTranslation } from '@frontend/i18n';
import { Button, PopoverMenu, PopoverMenuItem, usePopoverMenu } from '@frontend/design-system';
import { useCompactTableRowContext } from '../../../context/compact-table-row-context';
import { CompactTableData } from '../types';

type Props = {
  label?: string;
};

export const CompactTableRowActions = ({ label: labelProp }: Props) => {
  const { t } = useTranslation();
  const { isDisabled, tableId, id, rowActions, item } = useCompactTableRowContext();
  const { getTriggerProps, getMenuProps, close } = usePopoverMenu({
    interactionOptions: {
      listNavigation: {
        openOnArrowKeyDown: false,
      },
    },
    placement: 'left',
  });
  const triggerProps = getTriggerProps();
  const menuProps = getMenuProps();
  const visibleActions = useMemo(
    () => rowActions?.actions?.filter(({ hide }) => !(isFunction(hide) ? hide(item as CompactTableData) : hide)) || [],
    [rowActions, item]
  );

  return (
    <>
      {visibleActions.length > 0 && (
        <>
          <Button
            color='light'
            iconName='more'
            variant='secondary'
            size='small'
            label={labelProp ?? t('Action menu')}
            disabled={isDisabled}
            trackingId={`${tableId}-row-${id}-actions-button`}
            {...triggerProps}
          />
          <PopoverMenu {...menuProps} title={labelProp ?? ''} css={{ maxWidth: 320 }}>
            {visibleActions.map(({ Icon, label, onClick, disabled }) => {
              const labelString = isFunction(label) ? label(item as CompactTableData) : label;
              const disabledValue = isFunction(disabled) ? disabled(item as CompactTableData) : disabled;
              return (
                <PopoverMenuItem
                  key={labelString}
                  onClick={() => {
                    onClick?.(item as CompactTableData);
                    close();
                  }}
                  label={labelString}
                  Icon={Icon}
                  disabled={disabledValue}
                >
                  {labelString}
                </PopoverMenuItem>
              );
            })}
          </PopoverMenu>
        </>
      )}
    </>
  );
};
